import { Show } from "actions/SnackbarActions";
import { useState } from "react";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { Post } from "utils/request";

const useActions = (props) => {

    const {
        id,
        onUpdate = () => {},
        fileId
    } = props;

    const [modalComment, setModalComment] = useState(false);

    const dispatch = useDispatch();

    const { mutate: acceptMutate } = useMutation(async (variables) => {
        const form = new FormData();
        form.append("id", id);

        const response = await Post("lessons/files/comments/accept", form);
        return {
            ...response,
            silent: variables?.silent
        };
    }, {
        onSuccess: () => {
        }
    });

    const { mutate: deleteMutation, isLoading: deleteIsLoading } = useMutation(async (targetId = id) => {
        const form = new FormData();
        form.append("id", targetId);

        return await Post("lessons/files/comments/delete", form);
    }, {
        onSuccess: (data) => {
            onUpdate();
            dispatch(Show({
                show: true,
                message: data?.message
            }));
        }
    });

    const { mutate: editMutation, isLoading: editIsLoading } = useMutation(async (data) => {
        const form = new FormData();
        form.append("id", data?.id || id);
        form.append("file_id", data?.fileId || fileId);
        form.append("comment", data?.comment);

        return await Post("lessons/files/comments/alter", form);
    }, {
        onSuccess: (data) => {
            onUpdate();
            dispatch(Show({
                show: true,
                message: data?.message,
                severity: data?.severity
            }));
        }
    });

    const { mutate: replyMutation, isLoading: replyIsLoading } = useMutation(async (data) => {
        const form = new FormData();
        form.append("file_id", fileId);
        form.append("comment", data?.comment || data);
        form.append("reply_to", id);
        if (data?.accepted !== undefined) {
            form.append("accepted", data.accepted);
        }

        return await Post("lessons/files/comments/create", form);
    }, {
        onSuccess: (data, variables) => {
            dispatch(Show({
                show: true,
                message: variables?.adminReply
                    ? "Comentário feito com sucesso."
                    : data?.message,
                severity: data?.severity
            }));
        }
    });

    const openModalComment = () => setModalComment(true);
    const closeModalComment = () => setModalComment(false);

    return {
        modalComment: {
            state: modalComment,
            open: openModalComment,
            close: closeModalComment
        },
        accept: {
            mutate: acceptMutate
        },
        deleteActions: {
            mutate: deleteMutation,
            isLoading: deleteIsLoading
        },
        editActions: {
            mutate: editMutation,
            isLoading: editIsLoading
        },
        replyActions: {
            mutate: replyMutation,
            isLoading: replyIsLoading
        }
    };
}

export default useActions;
